import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { apiFetch } from "api/Api";
import { Link, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import "assets/theme/admin_form.css";

const AddSource = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    source_name: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.source_name.trim()) {
      newErrors.source_name = "Source name is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);
    try {
      const data = await apiFetch("super_admin/add_source", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      alert(data.message);
      navigate("/source_list");
    } catch (error) {
      console.error(error);
      alert("Failed to add source");
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="container-fluid mt-4" style={{ fontSize: "0.9rem" }}>
        {/* Header Card */}
        <div className="admin-form-header-card">
          <div className="d-flex align-items-center gap-3">
            <button type="button" onClick={() => navigate(-1)} className="btn-admin-back">
              <FaArrowLeft />
              <span>मागे जा (Back)</span>
            </button>
            <div>
              <h4 className="fw-bold mb-1 text-white">
                🌐 नवीन स्रोत जोडा (Add New Source)
              </h4>
              <small className="text-white-50">Create a source used for incoming request tracking</small>
            </div>
          </div>

          <Link to="/source_list" className="btn btn-light btn-sm fw-semibold rounded-pill px-3">
            Source List
          </Link>
        </div>

        <div className="card shadow-lg rounded-4 border-0">
          <div className="card-body p-4">
            <form onSubmit={handleSubmit} noValidate>
              <div className="row g-4">
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    Source Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    name="source_name"
                    className={`form-control ${errors.source_name ? "is-invalid" : ""}`}
                    placeholder="Enter source name (e.g., Online)"
                    value={formData.source_name}
                    onChange={handleChange}
                  />
                  {errors.source_name && (
                    <small className="text-danger d-block mt-1">{errors.source_name}</small>
                  )}
                </div>
              </div>

              <div className="mt-4 text-end">
                <button type="submit" className="btn btn-primary px-5" disabled={loading} style={{ fontSize: "0.85rem" }}>
                  {loading ? "Saving..." : "Save Source"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default AddSource;
